export default "__VITE_ASSET__CvVUSeZd__"